<template>
    <f7-page>
        <f7-navbar :title="packInfo&&packInfo.name" back-link="返回"></f7-navbar>
        <section class='detail_banner' v-if="packInfo">
            <img :src="mediaUrl()" class="goods_img goods_banner" alt="">
        </section>
        <section class="wrap" v-if="packInfo">
            <section class="pack_detail">
                <div class="title">{{packInfo.name}}</div>
                <div class="desc">{{packInfo.desc}}</div>
            </section>
            <section class="detailcontainer">
                <header class="header">商品详情</header>
                <div>
                    <img v-if="packInfo.image2" :src="packInfo.image2" alt="" class='width-100'>
                    <img v-if="packInfo.image3" :src="packInfo.image3" alt="" class='width-100'>
                    <img v-if="packInfo.image4" :src="packInfo.image4" alt="" class='width-100'>
                </div>
            </section>
        </section>
        <div slot="fixed">
            <div class='download-wrap'>
                <div class='download' v-if="pack.canBeInstall" active color="green" @click="installPack(pack,index)">
                    安装
                </div>
                <div class='download installed' v-else>已安装</div>
            </div>
        </div>
    </f7-page>
</template>

<script>
  import { f7Row, f7Col, f7Button } from 'framework7-vue'
  import { mapState } from 'vuex'
  import { globalConst as native, modalTitle } from '../../lib/const'
  import { getMediaUrl } from 'lib/common'
  import installPackageMixin from 'mixins/installPackageMixin'

  export default {
    name: '',
    props: {
      index: [Number, String],
      canBeInstall: [Number, String]
    },
    data () {
      return {
        pack: null,
        packInfo: null
      }
    },
    mixins: [installPackageMixin],
    created () {
      console.log('this.listFile===>', this.listFile)
      if (this.canBeInstall >>> 0) {
        this.pack = this.installListFile[this.index] || {}
      } else {
        this.pack = this.listFile[this.index] || {}
      }

      this.$store.dispatch({
        type: native.resDetail,
        guid: `{${this.pack.guid}}`
      }).then(({data}) => {
        this.packInfo = data
      })
    },
    methods: {
      mediaUrl () {
        return `${getMediaUrl()}${this.packInfo.image}`
      },
    },
    computed: {
      ...mapState({
        listFile: ({downLoader}) => downLoader.listFile,
        installListFile: ({downLoader}) => downLoader.installListFile,
        chkcode: ({downLoader}) => downLoader.chkcode,
        imbcode: ({downLoader}) => downLoader.imbcode,
        downLoaderServerUrl: ({downLoader}) => downLoader.downLoaderServerUrl
      })
    },
    components: {f7Row, f7Col, f7Button}
  }
</script>

<style lang="scss" scoped type="text/css">
    @import "../../css/packageDetail.scss";
</style>